<script>
  import { onMount } from "svelte";
  import { Router, Route } from "svelte-routing";
  import { Styles } from "sveltestrap";
  import ValdiatedRoute from "@/component/ValidatedRoute.svelte";
  import Start from "@/page/Start.svelte";
  import Payment from "@/page/Payment.svelte";
  import Success from "@/page/Success.svelte";
  import Error from "@/page/Error.svelte";

  onMount(async () => {});
</script>

<Styles />

<Router>
  <ValdiatedRoute path="/" redirectTo={Error} component={Start} />
  <Route path="/payment" redirectTo={Error} component={Payment} />
  <Route path="/success" component={Success} />
  <Route path="/error">
    <p style="margin: 60px">Error!</p>
  </Route>
</Router>

<style>
  :global(body) {
    padding: 20px;
  }
</style>
